module.exports = __webpack_public_path__ + "assets/img/my-vpp-bg.7358815c.png";